
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/terms-of-use",
      function () {
        return require("private-next-pages/[region]/[lang]/terms-of-use.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/terms-of-use"])
      });
    }
  